<svg width="40" height="28" viewBox="0 0 40 28" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
        <path d="M39.538 12.146C35.623 4.866 28.32 0 20 0 11.676 0 4.375 4.87.462 12.146a3.955 3.955 0 0 0 0 3.708C4.377 23.134 11.68 28 20 28c8.324 0 15.625-4.87 19.538-12.146a3.955 3.955 0 0 0 0-3.708zM20 24c-5.527 0-10-4.473-10-10S14.473 4 20 4s10 4.473 10 10-4.473 10-10 10zm0-4c-3.316 0-6-2.684-6-6s2.683-6 6-6c3.316 0 6 2.684 6 6s-2.683 6-6 6z" id="qvoh8padfa"/>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <mask id="9xfhrelxnb" fill="currentColor">
            <use xlink:href="#qvoh8padfa"/>
        </mask>
        <use fill="currentColor" fill-rule="nonzero" xlink:href="#qvoh8padfa"/>
        <g mask="url(#9xfhrelxnb)" fill="currentColor">
            <path d="M-11-6h60v40h-60z"/>
        </g>
    </g>
</svg>
